module.exports = __webpack_public_path__ + "static/media/property.9375a416.png";